import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSafeCta, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

import * as styles from "./styles.module.css";

const SingleCtaBlogCard = ({ blog }) => {
    const safeCta = getSafeCta(blog?.cta);
    return (
        <Cta data={safeCta} className="h-full w-full pr-0 after:hidden">
            <div
                className={`${styles.blogMediaCard} relative group h-full border border-stone/50 bg-white rounded p-3 sm:pb-4.5 sm:pt-4.75 sm:px-4.75 flex flex-col hover:no-underline group/blog-card lg:hover:shadow-lg  transition-shadow duration-300`}
            >
                <div>
                    {blog?.featuredImage && (
                        <div className="lg:h-29 overflow-hidden mb-5.25">
                            <Media
                                media={blog?.featuredImage}
                                className="w-full h-full object-cover lg:group-hover/blog-card:scale-110 transition-transform duration-300 aspect-video"
                            />
                        </div>
                    )}
                </div>
                <div>
                    {blog?.title && (
                        <p
                            className="line-clamp-4 body-small text-gray mb-5"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(blog?.title) }}
                        />
                    )}
                </div>
                {/* author */}
                <div>
                    {blog?.author && (
                        <div className="flex items-center gap-x-2.5 mb-3.25">
                            {blog.author?.avatar && (
                                <Media media={blog.author.avatar} className="object-cover rounded-full h-9.5 w-9.5" />
                            )}
                            <span className="tag-3">{`${blog?.author.firstName ?? ""} ${blog?.author.lastName ??
                                ""}`}</span>
                        </div>
                    )}
                </div>
                <div className="mt-auto flex flex-col gap-5">
                    <div className="flex flex-wrap gap-2">
                        {blog?.industry && (
                            <span
                                key={blog.industry?.[0].title}
                                className="filter-label inline-flex items-center py-2 lg:py-2.5 px-3 lg:px-5 text-xs lg:text-sm text-green bg-green/15 rounded-xs font-normal leading-none break-all"
                            >
                                {blog?.industry?.[0].title}{" "}
                                {blog?.industry.length > 1 ? `+${blog.industry.length - 1}` : ""}
                            </span>
                        )}
                    </div>
                    {blog.cta?.map((button, i) => (
                        <Cta
                            key={i}
                            data={button}
                            className="lg:group-hover/blog-card:text-dark-green lg:group-hover/blog-card:after:arrow-green-dark lg:group-hover/blog-card:after:translate-x-0.75"
                        />
                    ))}
                </div>
            </div>
        </Cta>
    );
};

export default SingleCtaBlogCard;
